import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";
import { toast } from "sonner";
import { useAuth } from "./auth-context";

const FavContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());
  const [products, setProducts] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) {
      setIds(new Set());
      setProducts([]);
      return;
    }
    try {
      const { data } = await api.get("/favorites");
      setProducts(data);
      setIds(new Set(data.map((p) => p.id)));
    } catch {
      /* ignore */
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const isFavorite = (id) => ids.has(id);

  const toggle = async (product) => {
    if (!user) {
      toast.error("Inicia sesión para guardar habituales");
      return false;
    }
    const currently = ids.has(product.id);
    // optimistic
    setIds((prev) => {
      const next = new Set(prev);
      if (currently) next.delete(product.id);
      else next.add(product.id);
      return next;
    });
    try {
      if (currently) {
        await api.delete(`/favorites/${product.id}`);
        setProducts((ps) => ps.filter((p) => p.id !== product.id));
        toast.success("Eliminado de Mis habituales");
      } else {
        await api.post(`/favorites/${product.id}`);
        setProducts((ps) => (ps.some((p) => p.id === product.id) ? ps : [...ps, product]));
        toast.success("Añadido a Mis habituales");
      }
      return !currently;
    } catch {
      // revert
      setIds((prev) => {
        const next = new Set(prev);
        if (currently) next.add(product.id);
        else next.delete(product.id);
        return next;
      });
      toast.error("No se pudo actualizar Mis habituales");
      return currently;
    }
  };

  return (
    <FavContext.Provider value={{ ids, products, isFavorite, toggle, refresh }}>
      {children}
    </FavContext.Provider>
  );
}

export const useFavorites = () => useContext(FavContext);
